import { PdsWidget } from '../../pds-widget';
import { NumberFilter } from '../../models/grid-widget/number-filter';
import { NumberField } from '../../models/grid-widget/number-field';
import { pdsUtils } from '../../pds-utils';
import {OrderedMap} from '../../models/ordered-map';
import { pdsLogger } from '../../pds-logger';
import { pdsI18n } from '../../pds-i18n';
let log = pdsLogger.prependLogger(pdsLogger.requiresLogger('gridWidget'), 'pds-gw-number-filter.ts');

let filterComparators;

export class PdsGwNumberFilter extends PdsWidget {
  is = 'pds-gw-number-filter';

  //Input
  id: string;

  //Input
  filter: NumberFilter;

  properties = {
    id: {
      type: String,
      value: null
    },
    filter: {
      value: null
    }
  };

  attached(): void {
    super.attached();
    this.watch('filter.comparator');

    let container: HTMLElement | null = this.querySelector('.pds-gw-number-filter-content');
    if (container != null) {
      container.addEventListener('modelValueChange', (event: Event) => {
        if (pdsUtils.is(event.target as HTMLElement, 'pds-number-widget[name$="-1"]')) {
          this.filter.searchValueNum = (event.target as any).modelValue;
        } else {
          this.filter.searchValueNum2 = (event.target as any).modelValue;
        }
        this.inputChange();
      });
    }
  }

  inputChange(): void {
    log('inputChange() called');
    this.filter.comparator = this.querySelector('select.pds-gw-number-filter-operator-select').value;

    if (this.isUsesUnits()) {
      let units1Selector = this.querySelector('select.number-units-1');
      if (units1Selector != null) {
        this.filter.selectedUnitConversion = Number(units1Selector.value);
      }
      let units2Selector = this.querySelector('select.number-units-2');
      if (units2Selector != null) {
        this.filter.selectedUnitConversion2 = Number(units2Selector.value);
      }
    }

    let event: Event = new Event('renderedElementValueChange', {bubbles: true});
    this.dispatchEvent(event);
  }

  getNumberField(): NumberField {
    log('getNumberField called');
    return <NumberField>this.filter.dataField;
  }

  isUsesUnits(): boolean {
    if (this.filter == null || this.filter.dataField == null) {
      return false;
    }

    return (<NumberField>this.filter.dataField).unitsMap != null;
  }

  getNumberFilterComparators(): Array<{ value: string, text: string }> {
    if (filterComparators == null) {
      filterComparators = [
        {
          value: '>=',
          text: '≥'
        },
        {
          value: '>',
          text: '>'
        },
        {
          value: '=',
          text: '='
        },
        {
          value: '<',
          text: '<'
        },
        {
          value: '<=',
          text: '≤'
        },
        {
          value: 'range',
          text: pdsI18n.getText('pds|grid widget|Range')
        }
      ];
    }
    return filterComparators;
  }

  getNumberFilterUnitOptions(): Array<{ value: string, text: string }> {
    let unitsMap: OrderedMap<number> | undefined = (<NumberField>this.filter.dataField).unitsMap;
    let returnArray:  Array<{ value: string, text: string }> = [];

    if (unitsMap != null) {
      for ( let unit of unitsMap.array) {
        returnArray.push({
          value: String(unit.value),
          text: unit.key
        });
      }
    }

    return returnArray;
  }

  getLabelText(): string {
    return this.filter.comparator === 'range' ? pdsI18n.getText('pds|grid widget|Above') : this.getNumberField().title;
  }

  getPlaceholderText(): string {
    if (this.filter == null || this.filter.dataField == null) {
      return '';
    }
    return this.getNumberField().placeholderText;
  }

  getValidationRule(attributeName: string): string | null {
    if (this.filter != null &&
      this.filter.dataField != null &&
      this.filter.dataField.validationRules != null) {
      return this.filter.dataField.validationRules[attributeName];
    }
    return null;
  }
}
